module.exports = __webpack_public_path__ + "img/create_profile.c6bf42a9.png";